/* istanbul ignore file */
import { useContext, createContext } from 'react';

import type { LanguageSwitcherPopupProps } from '../models';
import { TranslationKeys } from '../models';

export type ConfigurationContext = Pick<LanguageSwitcherPopupProps, 'currentLanguage' | 'tenant' | 'translations'> & {
  languages?: LanguageSwitcherPopupProps['prefetchedLanguages'];
};

export const configurationContextDefaultValues: ConfigurationContext = {
  currentLanguage: '',
  tenant: '',
  translations: TranslationKeys,
};

export const configurationContext = createContext<ConfigurationContext>(configurationContextDefaultValues);

export const ConfigurationProvider = configurationContext.Provider;

export const useConfiguration = () => useContext(configurationContext);
